<!-- InputField.vue -->
<template>
  <DbInput
    :placeholder="placeholder"
    :model-value="inputValue"
    :value="inputValue"
    @input="handleInput"
    :disabled="disabled"
    :ariainvalid="ariainvalid"
    class="w-full hydrated"
    type="number"
  ></DbInput>
</template>

<script setup lang="ts">
import { ref, defineProps, defineEmits } from "vue";
import DbInput from "../DB-Components/DbInput.vue";

const props = defineProps({
  modelValue: {
    type: Number || String,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: "",
  },
  ariainvalid: {
    type: String as () => "false" | "grammar" | "spelling" | "true" | undefined,
    default: "false",
    required: false,
  },
});
const inputValue = ref<number | null>(props.modelValue);
const emit = defineEmits(["update:modelValue"]);

const handleInput = (event: HTMLInputElement) => {
  const target = event.target as HTMLInputElement;
  const numericValue = parseFloat(target.value.replace(/\./g, ""));
  inputValue.value = isNaN(numericValue) || !numericValue ? null : numericValue;
  emit("update:modelValue", numericValue);
};
</script>
